module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap-validation/~/babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 1503
// module chunks = 0